import { Action, Store } from 'redux';

export class ReduxServiceProvider {
    private store!: Store;

    public setStore(store: Store) {
        this.store = store;
    }

    public getStore(): Store {
        return this.store;
    }

    public dispatch(action: Action) {
        return this.getStore()?.dispatch(action);
    }

    public getState() {
        return this.getStore()?.getState();
    }
}
